import axios from "axios";
import environment from "../environments/environment";

export const getImportStatusStreamUrl = (eventId, jobType) =>
  `${environment.apiUrl}/ticket/import/status-stream/${eventId}?ngrok-skip-browser-warning=true${jobType === "event_member_import" ? "&job_type=event_member_import" : ""}`;

export const getCertificateStatusStreamUrl = (eventId) =>
  `${environment.apiUrl}/ticket/certificate/status-stream/${eventId}?ngrok-skip-browser-warning=true`;

export const getTicketRegenerationStatusStreamUrl = (eventId) =>
  `${environment.apiUrl}/ticket/regeneration/status-stream/${eventId}?ngrok-skip-browser-warning=true`;

export const downloadRegistrationExport = async (ticketId) => {
  const response = await axios.get(
    `${environment.apiUrl}/ticket/exportRegistrations/${ticketId}`,
    {
      responseType: "blob",
      headers: { "ngrok-skip-browser-warning": "true" },
    }
  );
  const disposition = response.headers["content-disposition"] || "";
  const match = disposition.match(/filename="?([^"]+)"?/);
  const fileName = match ? match[1] : `registration_export_${ticketId}.csv`;
  return {
    blob: response.data,
    fileName,
    exportToken: response.headers["x-export-token"] || "",
  };
};

export const downloadEventRegistrationExport = async (eventId, type) => {
  const query = type !== undefined && type !== null && String(type).trim() !== ""
    ? `?type=${encodeURIComponent(type)}`
    : "";
  const response = await axios.get(
    `${environment.apiUrl}/ticket/exportRegistrationsEvent/${eventId}${query}`,
    {
      responseType: "blob",
      headers: { "ngrok-skip-browser-warning": "true" },
    }
  );
  const disposition = response.headers["content-disposition"] || "";
  const match = disposition.match(/filename="?([^"]+)"?/);
  const fileName = match ? match[1] : `registrations_${eventId}.csv`;
  return { blob: response.data, fileName };
};

export const updateImportData = (ticketId, formData) =>
  axios.post(`${environment.apiUrl}/ticket/updateImportData/${ticketId}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

export const updateEventImportData = (eventId, formData) =>
  axios.post(`${environment.apiUrl}/ticket/updateImportDataEvent/${eventId}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

export const getUpdateJobStatus = (jobId) =>
  axios.get(`${environment.apiUrl}/ticket/updateJobStatus/${jobId}`, {
    headers: { "ngrok-skip-browser-warning": "true" },
  });

export const getUpdateModeStatus = (eventId, type = "", ticketId = "") =>
  axios.get(
    `${environment.apiUrl}/ticket/updateMode/${eventId}?type=${encodeURIComponent(type)}${
      ticketId ? `&ticketId=${encodeURIComponent(ticketId)}` : ""
    }`,
    { headers: { "ngrok-skip-browser-warning": "true" } }
  );

export const enableUpdateMode = (eventId, type = "") =>
  axios.post(
    `${environment.apiUrl}/ticket/updateMode/${eventId}/enable?type=${encodeURIComponent(type)}`,
    {},
    { headers: { "ngrok-skip-browser-warning": "true" } }
  );

export const disableUpdateMode = (eventId, type = "") =>
  axios.post(
    `${environment.apiUrl}/ticket/updateMode/${eventId}/disable?type=${encodeURIComponent(type)}`,
    {},
    { headers: { "ngrok-skip-browser-warning": "true" } }
  );
